"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgHeart = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", className: "PayPing-icon" }, props),
        React.createElement("path", { d: "m12 3.7474c-1.989-5.8898-12-5.0149-12 3.8923 0 4.4378 3.06 10.343 12 16.36 8.94-6.0174 12-11.922 12-16.36 0-8.856-10-9.817-12-3.8923z" }))));
exports.default = SvgHeart;
//# sourceMappingURL=Heart.js.map